module.exports = __webpack_public_path__ + "static/media/microphone.64c1ca75.svg";